import { IconButton } from "@mui/material";
import { apiCreateNote, apiDeleteNote, apiGetItemNote } from "api/noteApi";
import PlusIcon from "assets/icons/PlusIcon";
import TrashIcon from "assets/icons/TrashIcon";
import NoteIcon from "assets/svg/factorHistoryIcon/Note";
import BasicButton from "components/BasicInputs/BasicButton";
import BasicTextInput from "components/BasicInputs/BasicTextInput";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

export interface NotesProps {
  detailId?: number;
  detailType?: string;
  onChange: (notes: any[]) => void;
}
export default function Notes(props: NotesProps) {
  const dispatch: any = useDispatch();
  const store = useSelector((x: any) => x);
  const token = store?.businessReducer?.business?.token;
  const [notes, setNotes] = useState<Partial<Note>[]>([]);
  const [status, setStatus] = useState(0);
  const [text, setText] = useState("");
  const id = props.detailId;
  const type = props.detailType;

  useEffect(() => {
    if (id && type) {
      dispatch(apiGetItemNote(token, id, type, (res: Note[]) => setNotes(res)));
    }
  }, [id, type]);

  function handleDelete(i: number) {
    const newNotes = notes.map((x, j) => (i === j ? { ...x, deletedAt: true } : x));
    setNotes(newNotes);
    props.onChange(newNotes);
  }
  function handleAdd() {
    const newNote: Partial<Note> = { text };
    const newNotes = [...notes, newNote];
    setStatus(0);
    setText("");
    setNotes(newNotes);
    props.onChange(newNotes);
  }

  return (
    <div className="flex flex-col gap-2 w-full">
        {notes?.map((note, i) => {
          if (note.deletedAt) return <></>;
          return (
            <>
              {i > 0 && <div className="min-h-[32px] w-px bg-slate-300 mr-8" />}
              <div key={i} className="flex items-center justify-between px-4 py-2">
                <div className="flex items-center gap-4">
                  <div className="bg-[#FFF8DE] w-8 h-8 rounded-full flex items-center justify-center">
                    <NoteIcon color="#D07E10" />
                  </div>
                  <span>{note.text}</span>
                </div>
                <div>
                  <IconButton onClick={() => handleDelete(i)}>
                    <TrashIcon color="#CB0B0B" />
                  </IconButton>
                </div>
              </div>
            </>
          );
        })}
      <div className="p-2 sticky bottom-0 bg-light-4 w-full mt-auto">
        {status === 1 && <BasicTextInput textArea onChange={(val) => setText(val.toString())} />}
        {status === 0 && (
          <BasicButton onClick={() => setStatus(1)}>
            <PlusIcon scale={0.6} color="#1062D0" />
            <span>ثبت یادداشت</span>
          </BasicButton>
        )}
        {status === 1 && (
          <BasicButton variant="contained" onClick={handleAdd}>
            <PlusIcon scale={0.6} color="#fff" />
            <span>ثبت یادداشت</span>
          </BasicButton>
        )}
      </div>
    </div>
  );
}
